import { useContext, useEffect, useState } from 'react'

import {
  Box,
  Button,
  CheckBox,
  Icon,
  Input,
  Text,
} from '@fairfashion/design-system'
import ReactGA from 'react-ga4'
import { Controller, useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'

import { AuthContext } from '../../../../contexts/auth'
import { ForgotPasswordModal } from '../ForgotPasswordModal/forgot-password-modal.comp'

import * as Styles from './login-form.styles'
import { LoginFormBody } from './login-form.types'

export const LoginForm = () => {
  const [showPassword, setShowPassword] = useState(false)
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false)
  const { companyId } = useParams()

  const { authentication, error } = useContext(AuthContext)

  const { register, control, handleSubmit, setValue } = useForm<LoginFormBody>({
    defaultValues: {
      email: '',
      password: '',
      rememberMe: false,
    },
  })

  useEffect(() => {
    const email = localStorage.getItem('email')
    if (email) {
      setValue('email', email)
      setValue('rememberMe', true)
    }
  }, [])

  const onSubmit = async (data: LoginFormBody) => {
    if (data.rememberMe) {
      localStorage.setItem('email', data.email)
    } else {
      localStorage.removeItem('email')
    }

    const login = await authentication(data.email, data.password)
    if (login) {
      ReactGA.event({
        category: 'User',
        action: 'Login',
        label: 'Successful',
      })
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box direction="column" gap={2} width="100%">
        <Input {...register('email')} type="email" label="Email" required />
        <Input
          {...register('password')}
          type={showPassword ? 'text' : 'password'}
          label="Senha"
          adornment={
            <Button
              variant="text"
              width="20px"
              padding="0"
              onClick={() => setShowPassword(!showPassword)}
            >
              <Icon
                size={20}
                name={showPassword ? 'eye_off_fill' : 'eye_fill'}
                color="grey_2"
              />
            </Button>
          }
          required
        />
        {!companyId && (
          <Box
            width="100%"
            justifyContent="space-between"
            marginY={1}
            alignItems="center"
          >
            <Box flex={1}>
              <Controller
                name="rememberMe"
                control={control}
                render={({ field }) => (
                  <CheckBox
                    label="Lembrar-me"
                    {...field}
                    checked={field.value}
                  />
                )}
              />
            </Box>
            <Box>
              <Styles.ForgotPasswordButton
                variant="text"
                color="info"
                padding="0"
                onClick={() => setShowForgotPasswordModal(true)}
              >
                Esqueceu a senha?
              </Styles.ForgotPasswordButton>
            </Box>
          </Box>
        )}
        {error && (
          <Box justifyContent="center" width="100%">
            <Text color="error" align="center" size="small">
              {error?.message}
            </Text>
          </Box>
        )}
        <Button width="100%" type="submit" color="white">
          Entrar
        </Button>
      </Box>
      <ForgotPasswordModal
        open={showForgotPasswordModal}
        onClose={() => setShowForgotPasswordModal(false)}
      />
    </form>
  )
}
